import * as yup from "yup";
import LocationSchema from "./Location";
const FoundHomeSchema = yup.object().shape({
  found_location: LocationSchema,
});

export default FoundHomeSchema;
